module.exports = __webpack_public_path__ + "img/bill_hero_desktop.0d0b434e.png";